import styled from 'styled-components';

const MontserratFont = styled.div`
  font-family: Montserrat;
  transform: scaleY(0.95);
`;

const MontserratLightFont = styled.div`
  font-family: MontserratLight;
  transform: scaleY(0.98);
`;

const StyledComponents = {
  MontserratFont,
  MontserratLightFont,
};

export default StyledComponents;
